import { FilterState } from 'contexts/filtersContext';
import { EditorialMarketType } from 'fxs-signals-insights/dist/models/enums';
import { EditorialMessage } from 'models/signalMessages';

type TagObject = { id: string; name?: string };
type Tag = string | TagObject;

const isFilterApplied = (filters: FilterState) => {
	return Object.keys(filters).some((filter) => {
		return filters[filter].length > 0;
	});
};

export const isMessageMatch = (
	filters: FilterState,
	mapped: EditorialMessage
) => {
	if (!isFilterApplied(filters)) return true;

	const result =
		filters.categories.includes(mapped.category) ||
		filters.markets.includes(mapped.market as EditorialMarketType) ||
		filters.tags.some((tagId) => {
			if (!mapped.tags) return false;
			return mapped.tags.some((mappedTag: Tag) => {
				if (typeof mappedTag === 'string') {
					return tagId === mappedTag.toUpperCase();
				} else if (
					mappedTag &&
					typeof mappedTag === 'object' &&
					'id' in mappedTag &&
					mappedTag.id
				) {
					return tagId === mappedTag.id.toUpperCase();
				}
				return false;
			});
		});
	return result;
};
